import { combineReducers } from 'redux'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'


const apiKey = handleActions(
  {
    [combineActions(actions.getApiKeyForOrgSuccess)]: (state, action) => {
      return action.payload[0]
    },
    [combineActions(actions.createApiKeyForOrgSuccess)]: (state, action) => {
      return action.payload
    }
  },
  {}
)

export default combineReducers({
  apiKey,
})


// WEBPACK FOOTER //
// ./src/modules/apiKey/reducer.js